import React, { createContext, useState, useEffect } from "react";
import axios from "axios";
import { useContext } from "react";
export const ClienteContext = createContext();

export function ClienteProvider({ children }) {
  const [parametros, setParametros] = useState(null);
  const [nomeCliente, setNomeCliente] = useState("");
  const [clienteId, setClienteId] = useState(localStorage.getItem("cliente_id"));

  useEffect(() => {
    if (!clienteId) return;

    axios
      .get(`http://localhost:5000/api/parametros_cliente/${clienteId}`)
      .then((res) => setParametros(res.data))
      .catch((err) =>
        console.error("Erro ao carregar parâmetros do cliente:", err)
      );

    axios
      .get(`http://localhost:5000/api/clientes/${clienteId}`)
      .then((res) => setNomeCliente(res.data.nome_fantasia))
      .catch((err) =>
        console.error("Erro ao carregar nome fantasia do cliente:", err)
      );
  }, [clienteId]);

  const atualizarCliente = (id) => {
    localStorage.setItem("cliente_id", id);
    setClienteId(id);
  };

  return (
    <ClienteContext.Provider value={{ parametros, nomeCliente, atualizarCliente }}>
      {children}
    </ClienteContext.Provider>
  );
}

export const useCliente = () => useContext(ClienteContext);
